import {createContext, useContext} from "react";
import {Locale} from "@/common/locales";

const DEFAULT_LOCALES_BY_TLD = new Map<string, string>([
  ["sg", Locale.EN_SG],
  ["in", Locale.EN_IN],
  ["us", Locale.EN_US],
]);

export function getDefaultLocale(): Locale {
  const hostname = window.location.hostname;
  for (const entry of DEFAULT_LOCALES_BY_TLD.entries()) {
    if (hostname.endsWith(`.${entry[0]}`)) {
      return entry[1] as Locale;
    }
  }
  return Locale.EN_001;
}

export const LocaleContext = createContext<Locale>(Locale.EN_001);

export const useLocale = () => useContext(LocaleContext);
